module.exports = __webpack_public_path__ + "static/media/Penny_Headshot.644120c0.png";